import React from "react";
import NotFound from "../assets/not-found.jpeg";

interface NotFoundImageProps {
  alt?: string;
  className?: string;
}

const NotFoundImage: React.FC<NotFoundImageProps> = ({
  alt = "Not Found",
  className = "",
}) => {
  return (
    <div className={`w-full flex justify-center ${className}`}>
      <img
        src={NotFound}
        alt={alt}
        className="w-full max-w-full h-auto object-contain"
      />
    </div>
  );
};

export default NotFoundImage;